import { DELIVERY_QUERY_KEY } from '@/features/delivery/config/constants';

export const deliveryKey = (id: string) => [DELIVERY_QUERY_KEY, 'delivery', id] as const;
export const summaryKey = (id: string) => [DELIVERY_QUERY_KEY, 'summary', id] as const;
export const entriesKey = (id: string) => [DELIVERY_QUERY_KEY, 'entries', id] as const;
